// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".links[data-v-99767614]{align-items:center;color:#000!important;font-size:1.02rem;font-weight:500;margin:auto 10px;-webkit-text-decoration:none;text-decoration:none;transition:padding .5s}.links[data-v-99767614]:hover{background:#e3f2fd;padding:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
